export default function MapboxCredits() {
  return (
    <div className="px-2 pb-1 tw-text-gray-400 tw-text-[8px] text-center">
      ©{' '}
      <a
        href="https://www.mapbox.com/about/maps/"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        Mapbox
      </a>{' '}
      ©{' '}
      <a
        href="http://www.openstreetmap.org/copyright"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        OpenStreetMap
      </a>{' '}
      <strong>
        <a
          href="https://www.mapbox.com/map-feedback/"
          rel="noopener noreferrer nofollow"
          target="_blank"
          className="tw-underline"
        >
          Improve this map
        </a>
      </strong>
    </div>
  );
}
